import { onSnapshot } from "firebase/firestore";

/**
 * Lắng nghe Query hoặc DocumentReference realtime.
 * mapAsync (tuỳ chọn): biến docs thô → dữ liệu UI (ganTen…).
 * Trả về hàm hủy (unsubscribe). Bỏ qua kết quả cũ nếu có snapshot mới hơn.
 *
 * @param {import("firebase/firestore").Query | import("firebase/firestore").DocumentReference} target
 * @param {{ mapAsync?: (raw: any) => Promise<any> | any, onChange: (data: any) => void, onError?: (err: Error) => void }} opts
 */
export function langNgheFirestore(target, { mapAsync, onChange, onError }) {
  let lan = 0;
  return onSnapshot(
    target,
    async (snap) => {
      const lanNay = ++lan;
      try {
        let raw;
        if (typeof snap.docs !== "undefined") {
          raw = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        } else if (snap.exists()) {
          raw = { id: snap.id, ...snap.data() };
        } else {
          raw = null;
        }
        const data = mapAsync ? await mapAsync(raw) : raw;
        if (lanNay !== lan) return;
        onChange(data);
      } catch (err) {
        if (lanNay === lan) onError?.(err);
      }
    },
    (err) => onError?.(err)
  );
}
